import { render, staticRenderFns } from "./DailyAllowance.vue?vue&type=template&id=1b9367e4&"
import script from "./DailyAllowance.vue?vue&type=script&lang=ts&"
export * from "./DailyAllowance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports